(function () {
  class Shaker extends PIXI.Container {
    constructor(objectId, threshold, magnitude) {
      super();

      this._objectId = objectId;
      this._threshold = threshold;
      this._dir = 0;
      this._magnitude = magnitude;
      this._alreadyShook = false;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:WinningLinesEvent', this.doPayWins.bind(this));
      messageBus.subscribe('spinner:SpinStartEvent', this.onSpinStart.bind(this));
    }

    onSpinStart() {
      this._alreadyShook = false;
    }

    // Called by overlayDisplay after mystery symbol reveal
    triggerShake(totalWinnings) {
      const stake = gameController.getCurrentModeStake();
      if (totalWinnings >= stake * this._threshold) {
        this._alreadyShook = true;
        this.shake();
        const self = this;
        timerManager.addTimeout(1500, function () {
          timerManager.stop(self.shakeTimer);
          self._object.position.setX(self._resetPos.x);
        });
      }
    }

    onGameConfigEvent() {
      this._object = resourceManager.get(this._objectId);
      this._resetPos = layoutController.getCurrentPosition(this._objectId);
    }

    doPayWins(task) {
      if (this._alreadyShook) return; // Already shook after mystery reveal

      const stake = gameController.getCurrentModeStake();
      if (task.data.totalLineWinnings >= stake * this._threshold) {
        // soundManager.play("alarmBell");
        this.shake();
        const self = this;
        timerManager.addTimeout(1500, function () {
          timerManager.stop(self.shakeTimer);
          self._object.position.setX(self._resetPos.x);
        });
      }
    }

    shake() {
      if (this._dir > 0) {
        this._dir = -1;
      } else {
        this._dir = 1;
      }
      const self = this;
      this.shakeTimer = timerManager.addTimer(
        50,
        function (progress) {
          const startPos = layoutController.getCurrentPosition(self._objectId);
          const endX = startPos.x + self._magnitude * self._dir;
          const distance = (endX - startPos.x) * progress;
          self._object.position.setX(startPos.x + distance);
        },
        function () {
          const startPos = layoutController.getCurrentPosition(self._objectId);
          self._object.position.setX(startPos.x);
          self.shake();
        }
      );
    }
  }

  var shakerCreator = function (json) {
    return new Shaker(json.objectId, json.threshold, json.magnitude);
  };

  var shakerInitialiser = function (json, shaker) {};

  var shakerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('shaker', shakerCreator, shakerInitialiser, shakerFilesRequired);
})();
